import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Authentication
import { UserResolver } from './user/user.resolver';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "login",
    loadChildren: () =>
      import("./auth/auth.module").then(
        m => m.AuthModule
      )
  },
  {
    path: "app",
    loadChildren: () =>
      import("./application/application.module").then(
        m => m.ApplicationModule
      ),
    canActivate: [AuthGuard]
  },
  { path: "**", redirectTo: "404" },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
